export default __webpack_public_path__ + "static/media/hdb.d100cf93.svg";